import React from 'react';
interface LogoProps {
  isHomePage?: boolean;
  isFooter?: boolean;
}
const Logo: React.FC<LogoProps> = ({
  isHomePage = false,
  isFooter = false
}) => {
  return <div className={`flex items-center ${isFooter ? 'scale-126 sm:scale-105' : 'scale-238'}`} data-id="element-725" data-mp="10c1be1zlbw0t">
      <img src="https://www.conversion.com.br/wp-content/uploads/2025/05/logo-conversion.svg" alt="Conversion Logo" className={`${isFooter ? 'h-4 sm:h-4 md:h-4 lg:h-4.5 xl:h-6' : 'h-7 sm:h-8 md:h-10.5 lg:h-11.5'} mr-0.5 sm:mr-0.5 md:mr-1 lg:mr-1.5`} onError={e => {
      e.target.src = 'https://www.conversion.com.br/wp-content/uploads/2025/05/logo-conversion.svg';
    }} data-id="element-726" data-mp="rd61aetfe1s8" />
      <span className={`${isFooter ? 'text-xs sm:text-xs md:text-xs lg:text-xs xl:text-sm' : 'text-base sm:text-lg md:text-xl lg:text-2xl'} font-semibold md:font-medium lg:font-normal ${isHomePage ? 'text-gray-900' : 'text-gray-900'} whitespace-nowrap`} data-id="element-727" data-mp="8npoot4guivg">
        | Semantic Branding
      </span>
    </div>;
};
export default Logo;